import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { authApi } from 'api';
import { QueryKey } from 'enums';
import { authUtils } from 'utils';

export const useOrderAuth = () => {
  const params = useParams<{ id: string; token: string }>();
  const authData = useMemo(
    () => ({ orderId: params.id as string, token: params.token as string }),
    [params],
  );
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticationFailed, setAuthenticationFailed] = useState(false);

  const { isLoading: isAuthLoading } = useQuery(
    [QueryKey.Login, authData],
    () => authApi.login(authData),
    {
      enabled: !authenticated && !authenticationFailed,
      retry: false,
      onSuccess: (response: { accessToken: string }) => {
        authUtils.setAuthData(authData);
        authUtils.setAccessToken(response.accessToken);
        setAuthenticated(true);
      },
      onError: () => {
        setAuthenticationFailed(true);
      },
    },
  );

  return {
    orderId: authData.orderId,
    authenticated,
    authenticationFailed,
    setAuthenticationFailed,
    isAuthLoading,
  };
};
